<!--
 * @Author: WLL
 * @Date: 2020-04-13 21:38:24
 * @LastEditors: WLL
 * @LastEditTime: 2020-05-06 19:18:32
 * @Description: 通用展示组件
 -->
<template>
  <div class="displayArea">
    <div
      :class="[
        'displayArea_titleBox',
        {
          displayArea_title_splitline: showSplitline
        }
      ]"
    >
      <div class="displayArea_titleBox_wrapper">
        <i
          v-if="showIcon"
          class="displayArea_title_icon"
          :class="iconClass"
          :style="{ fontSize: iconSize, color: iconColor }"
        ></i>
        <div class="displayArea_title">{{ title }}</div>
        <slot name="titleLeft"></slot>
      </div>
      <div class="displayArea_titleBox_wrapper">
        <slot name="titleRight"></slot>
        <SjIcon
          class="displayArea_title_more"
          fontFamily="icon_xh"
          iconClass="iconicon_operation"
          v-if="showMore"
          @click="$emit('more')"
        ></SjIcon>
      </div>
    </div>
    <div class="displayArea_contentBox">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "DisplayArea",
  props: {
    title: String,
    showSplitline: {
      type: Boolean,
      default: true
    },
    showIcon: {
      type: Boolean,
      default: true
    },
    iconClass: {
      type: String,
      default: "icon_xh iconicon_new"
    },
    iconSize: {
      type: String,
      default: "20px"
    },
    iconColor: {
      type: String,
      default: "#ff5c47"
    },
    showMore: {
      type: Boolean,
      default: true
    }
  }
};
</script>

<style lang="less" scoped>
.displayArea {
  height: 100%;
  display: flex;
  flex-direction: column;

  .displayArea_titleBox {
    padding: 8px;
    display: flex;
    align-items: center;
    justify-content: space-between;

    &.displayArea_title_splitline {
      border-bottom: 1px solid @color-highlight-xh;
    }

    .displayArea_titleBox_wrapper {
      display: flex;
      align-items: center;
      overflow: hidden;
    }

    .displayArea_title_icon {
      margin-right: 5px;
    }

    .displayArea_title {
      .text("caption", "label-xh", "semibold");
      flex-shrink: 0;
      .text-ellipsis();
      font-size: 14px;
    }

    .displayArea_title_more {
      color: @color-gray-4;
      flex-shrink: 0;
    }
  }

  .displayArea_contentBox {
    flex: 1;
    min-height: 0;
    overflow: hidden;
  }
}
</style>
